import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome-layer-text',
	templateUrl:'./FontAwesomeLayerTextPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomeLayerTextPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeLayerTextPluginCompPage
{
	mdContent_935 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.FontAwesomeLayerText;
\`\`\``;
	mdContent_936 = `\`\`\`java
FontAwesomeLayerText()
\`\`\``;
	mdContent_937 = `\`\`\`java
var text = new FontAwesomeLayerText<>()
    .setText("FREE")
    .transform(FontAwesomeTransforms.Shrink_4);
\`\`\``;
}
